import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../services/entities';

@Pipe({
  name: 'productQuality'
})
export class ProductQualityPipe implements PipeTransform {
  transform(product: Product): { quality: number; classString: string } {
    const quality = +product.qualityCategoryAbbreviation.replace('*', '');
    let classString = '';

    switch (quality) {
      case 3:
        classString = 'blue';
        break;
      case 4:
        classString = 'red';
        break;

      case 5:
        classString = 'black';
        break;
      case 6:
        classString = 'grey';
        break;
      case 7:
        classString = 'gold';
        break;
    }

    return { quality, classString };
  }
}
